<template>
    <div class="RePresentaionMyObjButton">
        <base-button @click="AddToPres" type="primary" class="btn mt-0" simple>Создать презентацию {{ object_id }}</base-button>

        <div class="d-flex" v-if="presentationLink != ''">
            <a :href="$GVO.endpoint_domen+this.presentationLink+'?isagent=true'" target="__blank">Посмотреть презентацию</a>
        </div>

    </div>
</template>
<script>
import { Button } from 'element-ui';
export default {
    name: 'RePresentaionMyObjButton',
    components: {
        [Button.name]: Button,
    },
    props: {

        task_id:{
            type: [String, Number],
        },
        taskend_id:{
            type: [String, Number],
        },
        service_id:{
            type: [String, Number],
        },
        client_id:{
            type: [String, Number],
        },
        object_id:{
            type: [String, Number],
        },

    },
    data () {
        return {
            bIsShown: false,
            presentationLink: '',
            isShown:false,
            myObj:{},
        }
    },
    methods: {
        
        AddToPres(){
            // const objGetParams = this.$GVO.GetAllGet();
            if(!this.$GVO.isEmpty(this.task_id)){
                this.$GVO.ApiCall('INSUPD_OBJ_TO_PRES',{
                    obj:'presentations',
                    flt:{
                        client_id:this.client_id,
                        task_id:this.task_id,
                        taskend_id:this.taskend_id
                    },iData:{
                        app_id:this.object_id,
                        type: 3 //тип MyObj
                    }
                })
                .then((objApi) => {
                    if(objApi.success === true){
                        // this.objData.inPresentation = 1;
                        this.getMyObjData();
                        this.printPress();
                    }
                }).catch(errorObjApi => {this.ApiData = []; console.error(errorObjApi);});
            }else{
                alert('Нет параметров задачи и клиента');
            }
        },
        printPress(){
            // let objItogGetParams = this.$GVO.GetAllGet();
            this.$GVO.ApiCall('CREATE_PRESENTATION',{obj:'presentations',flt:{'task_id':this.task_id,'taskend_id':this.taskend_id,'client_id':this.client_id}, iData:{}}) 
            //сварить сюда данные по слуге и объекту?
            .then((objApi) => {
                if(objApi.success === true){
                    this.presentationLink = objApi.data.link;
                }
            }).catch(errorObjApi => {this.ApiData = []; console.error(errorObjApi);});
        },
        getMyObjData(){
            // let objRet = {};
            this.$GVO.ApiCall('MyObj.GET',{flt:{id:this.object_id}}) //,...{c2p:this.c2p} -- это для выборки по 20, 50 тп
			.then((objApi) => {
				if(objApi.success === true){
					
					if(objApi.data.length > 0){
						this.myObj = objApi.data[0];
						// console.log('this.myObj', this.myObj);
					}
				}else{
					this.myObj = {};
				}
			}).catch(errorObjApi => {console.error(errorObjApi);});
        }
    },
    mounted(){
        
    }
}
</script>
<style scoped>
.RePresentaionMyObjButton {display: flex; flex-direction: column; width: 100%;}
.message-container {display: inline-flex; width: 100%;}

</style>